
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexYTkfKfF_45k20GUzxvoI_45tIivLdzMqrU6c8gulSZM3mjgMeta } from "/home/bella/vhosts/bella-nuxt/pages/index.vue?macro=true";
import { default as acessoKTPoEfW1rBVMeKD0YYUF31RTqGLpYuzhZCxa_5KUVgQMeta } from "/home/bella/vhosts/bella-nuxt/pages/acesso.vue?macro=true";
import { default as limpar_45cacheEO4RwB3_zUACu_pJQjtco_htqtnqAhjWmoeT68BY6EIMeta } from "/home/bella/vhosts/bella-nuxt/pages/limpar-cache.vue?macro=true";
import { default as livet4SGBQBQySwqrs5Z_45FyuJ8N0bkeLRKqONWE3A8r_aTQMeta } from "/home/bella/vhosts/bella-nuxt/pages/[language]/live.vue?macro=true";
import { default as indexE2jfBiXtOVrg08fqgMeQDuD7oOyvD3rrerer1h3TYAkMeta } from "/home/bella/vhosts/bella-nuxt/pages/[language]/index.vue?macro=true";
import { default as loginl1sXEQb5GF5yzi8XSAPCSJkxeH0HotJcS8vh_45LWuiqIMeta } from "/home/bella/vhosts/bella-nuxt/pages/[language]/login.vue?macro=true";
import { default as sobre0IsKCOg8S5dpkIkNuMPx_45QOTPKVGhOow0gBkd83O13wMeta } from "/home/bella/vhosts/bella-nuxt/pages/[language]/sobre.vue?macro=true";
import { default as ecardsBzfe79aFln8DKpzHOJIy27UW1VgJppbJJU996BQjM08Meta } from "/home/bella/vhosts/bella-nuxt/pages/[language]/ecards.vue?macro=true";
import { default as contato1kdfE7ecTV1azYyS16nrdpAQ8K_WSLg9SbVl2t9fUrEMeta } from "/home/bella/vhosts/bella-nuxt/pages/[language]/contato.vue?macro=true";
import { default as renovarV_e8r0iWPt2HXn0LBoNlXdCNeH2QAfQ3_6CA1t46M_MMeta } from "/home/bella/vhosts/bella-nuxt/pages/[language]/renovar.vue?macro=true";
import { default as freetourNHF7_45tVritUY7qItsdWCxyykAMoha7YPN2XVmgR7ZfIMeta } from "/home/bella/vhosts/bella-nuxt/pages/[language]/freetour.vue?macro=true";
import { default as imprensaNNyzn6_4tjmUzFwBpNd7eouKtjqupy5QjedZQuZU2jsMeta } from "/home/bella/vhosts/bella-nuxt/pages/[language]/imprensa.vue?macro=true";
import { default as indexN9NIhIdXY5YdOCw2_45DBZl3GD0B0j_45DzqVKwk5hbtpCMMeta } from "/home/bella/vhosts/bella-nuxt/pages/[language]/blog/index.vue?macro=true";
import { default as cancelformdno5yl4LeQlfiyvE53nJyl68H0mO_451KLlib2DFU4xQ0Meta } from "/home/bella/vhosts/bella-nuxt/pages/[language]/cancelform.vue?macro=true";
import { default as minhacontaKinR1TRKQoQCFgi2fiwAwGgfQSfLT3TQIfaqj6_45_45CNkMeta } from "/home/bella/vhosts/bella-nuxt/pages/[language]/minhaconta.vue?macro=true";
import { default as indexHI_45xUGYnwAF3STI_45IwT_CB7_45gHVQRakuaYLVFicalFkMeta } from "/home/bella/vhosts/bella-nuxt/pages/[language]/lives/index.vue?macro=true";
import { default as indexQMwc6ncvctDYilJZShP1Q_pqY7Q0oTQEGm7E5vQtMbAMeta } from "/home/bella/vhosts/bella-nuxt/pages/[language]/assine/index.vue?macro=true";
import { default as turboV4XB8pUo_45wK1ZInJWzy_45wlfHWMvbbb7l9bwWVWz8eFMMeta } from "/home/bella/vhosts/bella-nuxt/pages/[language]/assine/turbo.vue?macro=true";
import { default as index2uHgfqf9TThghuTK4O8Z1Fvs71hOdclHJ6cBE0SLuLIMeta } from "/home/bella/vhosts/bella-nuxt/pages/[language]/videos/index.vue?macro=true";
import { default as periody88SPolOMiNs_45PjbSfqPayVSbTTyelmIgosUdRr7c_45YMeta } from "/home/bella/vhosts/bella-nuxt/pages/[language]/assine/period.vue?macro=true";
import { default as index4d9K9ib1CtTr28IZK_45Gf0Xha_SdVZyosWVx7WXODRCMMeta } from "/home/bella/vhosts/bella-nuxt/pages/[language]/colunas/index.vue?macro=true";
import { default as indexNuDVHw6K7nDHAjLiGQtbcOi3gYxsPMg_qTeGYoOt6gUMeta } from "/home/bella/vhosts/bella-nuxt/pages/[language]/modelos/index.vue?macro=true";
import { default as indexCNRjFoGTMfqAQxdb_45B3atDqIQOlvBwfLxCmN576TyNwMeta } from "/home/bella/vhosts/bella-nuxt/pages/[language]/afiliado/index.vue?macro=true";
import { default as accountwmgLYKtN2q5Ep_QY95k1YropJZaRGVTiS8MwXgQ5groMeta } from "/home/bella/vhosts/bella-nuxt/pages/[language]/assine/account.vue?macro=true";
import { default as creditsTDIPa7G1zu3hH0YIp1z638yAjT9qK1ibi_45PJtKbqkiEMeta } from "/home/bella/vhosts/bella-nuxt/pages/[language]/assine/credits.vue?macro=true";
import { default as topLoc77tSNb_45KqPZlRBShv4s1_45gK0N6LnKziWNvWrZ9a0Meta } from "/home/bella/vhosts/bella-nuxt/pages/[language]/bellacloud/top.vue?macro=true";
import { default as indexC9YoReA2F0Ronmns7Gen6oWaQGYvhqOVPuGVRIbpenUMeta } from "/home/bella/vhosts/bella-nuxt/pages/[language]/palpitao/index.vue?macro=true";
import { default as previas_45gratisUu0GHc_451SKMRWYov_tWDHMi0qa9ivXF8X5MiT9SNXh4Meta } from "/home/bella/vhosts/bella-nuxt/pages/[language]/previas-gratis.vue?macro=true";
import { default as indexK9CE7b_457eAkz14X6M7aRZYwTziUN0YS_45melzo7OUklkMeta } from "/home/bella/vhosts/bella-nuxt/pages/[language]/afiliado/painel/index.vue?macro=true";
import { default as linksGv5ST1YPuUYKbioYC71mk_45QU_45w8_45YWjQN_Hr6OLJxD8Meta } from "/home/bella/vhosts/bella-nuxt/pages/[language]/afiliado/painel/links.vue?macro=true";
import { default as materialv2tHlDY7laNKCLwALa2e99_45ONRhzAyXEnwhKFyCKkjYMeta } from "/home/bella/vhosts/bella-nuxt/pages/[language]/afiliado/painel/material.vue?macro=true";
import { default as painels6xd1kFlDQDsodIv2XUn2HSv8mMI778SE4dxElCN54EMeta } from "/home/bella/vhosts/bella-nuxt/pages/[language]/afiliado/painel.vue?macro=true";
import { default as indexgT09PRxwD14A39cXqRd5zeAXQaiFQ_RsB5HOBpYbGFsMeta } from "/home/bella/vhosts/bella-nuxt/pages/[language]/area-gold/index.vue?macro=true";
import { default as checkoutfZWyb4HvAJSvBDvPJgS8QO6f_45dieelWU3bO6eGQsQ48Meta } from "/home/bella/vhosts/bella-nuxt/pages/[language]/assine/checkout.vue?macro=true";
import { default as indexlrAumnhLlvyyb9GP0jSrad6yqwMtxLFwbodJ_dStD_45AMeta } from "/home/bella/vhosts/bella-nuxt/pages/[language]/making-of/index.vue?macro=true";
import { default as indexV3iMkxFFtV8pRL1mofE0Ra_45yU8_FE_IOOu7X9gBQRhQMeta } from "/home/bella/vhosts/bella-nuxt/pages/[language]/bellacloud/index.vue?macro=true";
import { default as _91slug_93W_VuRFdSp8KEEYjgZT_45LinwHrM6o8yMrDhM2CHBqIE4Meta } from "/home/bella/vhosts/bella-nuxt/pages/[language]/blog/[id]/[slug].vue?macro=true";
import { default as homepage_45previewceWz9dQQWCiQo08_ptlOEveMq95uAUkZELf9Qsh9qaMMeta } from "/home/bella/vhosts/bella-nuxt/pages/[language]/homepage-preview.vue?macro=true";
import { default as indexKRe2uLHUIdFz70FVXQ0RQsiStVwlAntsmFkmNklTOdgMeta } from "/home/bella/vhosts/bella-nuxt/pages/[language]/me/credits/index.vue?macro=true";
import { default as indextciZdWe00nGPpo8aQr_45ofPRtqjxrOKRV_454qM11eMJTAMeta } from "/home/bella/vhosts/bella-nuxt/pages/[language]/publicidade/index.vue?macro=true";
import { default as liveJC7ebG4x33vVB_45T16_jlXg6Mo6kaU7jbYmKiLQFzUwUMeta } from "/home/bella/vhosts/bella-nuxt/pages/[language]/modelos/[name]/live.vue?macro=true";
import { default as index11nwsFQoRrgdWE4eifUpzBOGk35U9CrqxsH3QmVY_EQMeta } from "/home/bella/vhosts/bella-nuxt/pages/[language]/modelos/[name]/index.vue?macro=true";
import { default as photofj7onn9Kv_452yaC0Safo5VeT4JsaNSxklkNITqg3Pby0Meta } from "/home/bella/vhosts/bella-nuxt/pages/[language]/modelos/[name]/photo.vue?macro=true";
import { default as videoNHDog1XVh3Jlb_x8h6voznLxtRJeV0JQfy2v8qI0yJMMeta } from "/home/bella/vhosts/bella-nuxt/pages/[language]/modelos/[name]/video.vue?macro=true";
import { default as perfildk0f4ws_MAAHFqiDWo1pRaJI2fqNPXrwFI58pZ4bVMMMeta } from "/home/bella/vhosts/bella-nuxt/pages/[language]/modelos/[name]/perfil.vue?macro=true";
import { default as dna_45bellaahDaBkkGrWPsku_45VWn2djAK8VCBks9azLS8dDhgwYvUMeta } from "/home/bella/vhosts/bella-nuxt/pages/[language]/publicidade/dna-bella.vue?macro=true";
import { default as _91slug_93UiUF9VujX_45_45izpMvYB0dyhJl_w0Lflvry28ddw7MudMMeta } from "/home/bella/vhosts/bella-nuxt/pages/[language]/lives/categoria/[slug].vue?macro=true";
import { default as creditsCOJhHiTTqWmhVabV7_45j_4557G4Fdx9JYa9l2gq43pAl0MMeta } from "/home/bella/vhosts/bella-nuxt/pages/[language]/modelos/[name]/credits.vue?macro=true";
import { default as checkout_45successODk6NZUUjpsEUI18HE_45y6a6SVDaz2KnKs4NjMZ4K1WYMeta } from "/home/bella/vhosts/bella-nuxt/pages/[language]/assine/checkout-success.vue?macro=true";
import { default as politica_45de_45privacidadeQrRrwueMsGSr7mmr3s16VALZFpsxAR04yBqO9RRjR0oMeta } from "/home/bella/vhosts/bella-nuxt/pages/[language]/politica-de-privacidade.vue?macro=true";
import { default as _91slug_93cnIZUk051m8PcvyRa1gqODYAOYfU5RL_45QriJ3RG_450WgMeta } from "/home/bella/vhosts/bella-nuxt/pages/[language]/videos/categoria/[slug].vue?macro=true";
import { default as _91token_934G_1ghMnQgYIHTEs10L_54JqYRuhy2JdUjuqxoMl17cMeta } from "/home/bella/vhosts/bella-nuxt/pages/[language]/cancel-subscribe/[token].vue?macro=true";
import { default as making_45ofbidhWd2W4cEmudh4LXWdkQG37TnmdL6I514rJN2oztsMeta } from "/home/bella/vhosts/bella-nuxt/pages/[language]/modelos/[name]/making-of.vue?macro=true";
import { default as wallpaper43gMM_mM7T_gq853d7posm2JZfOCArON20uBp9EpCqcMeta } from "/home/bella/vhosts/bella-nuxt/pages/[language]/modelos/[name]/wallpaper.vue?macro=true";
import { default as _91slug_93qpe4iQZkmX6jGwr90IvalLqUXL64BY_45y82fPqkHjR6gMeta } from "/home/bella/vhosts/bella-nuxt/pages/[language]/modelos/categoria/[slug].vue?macro=true";
import { default as politica_45de_45cancelamentoeXtxEJechJZZrZk_yfJN9dS1BUSV69IMU8UQw3p3G0YMeta } from "/home/bella/vhosts/bella-nuxt/pages/[language]/politica-de-cancelamento.vue?macro=true";
import { default as indexnn9ppbK_BtZ6Qqewt3Dn_7aK55RKeauLR_bo1Y6jhUkMeta } from "/home/bella/vhosts/bella-nuxt/pages/[language]/programa-afiliados/index.vue?macro=true";
import { default as _91slug_93CyeGVfGoTPY4fHWAz4BNzADJzbtSujTWENIB9LTFpOEMeta } from "/home/bella/vhosts/bella-nuxt/pages/[language]/making-of/categoria/[slug].vue?macro=true";
import { default as videos_45downloadsycE1Kz79jfllIejwKNUj7MRZhfEklZ0aYadteIUtKHEMeta } from "/home/bella/vhosts/bella-nuxt/pages/[language]/me/credits/videos-downloads.vue?macro=true";
import { default as _91token_93J7rMZ14aU3DIfuKWQjJ1G0oiwAktHFbzLtRcTmkx5NEMeta } from "/home/bella/vhosts/bella-nuxt/pages/[language]/password-reset/[email]/[token].vue?macro=true";
import { default as checkout_45credits_45successwow3QysC4U_45pIhZyuadoHtCI27UNpY4i_aZoY9qjP7kMeta } from "/home/bella/vhosts/bella-nuxt/pages/[language]/assine/checkout-credits-success.vue?macro=true";
import { default as _91complement_93V2HIMf_ZZHumwgm7C5oBWd_JHtNrL4oI71Q_3E8OMzgMeta } from "/home/bella/vhosts/bella-nuxt/pages/[language]/programa-afiliados/[complement].vue?macro=true";
import { default as _91nameAlbum_93UC1aRNRJxEjUtDkQW9VvFTxkM2z_j6b5Na4IpqerTFMMeta } from "/home/bella/vhosts/bella-nuxt/pages/[language]/bellacloud/album/view/[albumId]/[nameAlbum].vue?macro=true";
import { default as indexWcfihC1eoFvXOl_vo3_459uhj_45Z6y9FBb7fKH7TbagXsEMeta } from "/home/bella/vhosts/bella-nuxt/pages/[language]/colunas/[catergoriaId]/[categoriaName]/index.vue?macro=true";
import { default as _91colunaName_93eJ4P9Mn8aGMfmgHWk1QTVOEX_45kt6oGjZ7qT4EzKx0lgMeta } from "/home/bella/vhosts/bella-nuxt/pages/[language]/colunas/[catergoriaId]/[categoriaName]/[colunaId]/[colunaName].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: {"middleware":["lang-redirect"]},
    component: () => import("/home/bella/vhosts/bella-nuxt/pages/index.vue")
  },
  {
    name: "acesso",
    path: "/acesso",
    meta: acessoKTPoEfW1rBVMeKD0YYUF31RTqGLpYuzhZCxa_5KUVgQMeta || {},
    component: () => import("/home/bella/vhosts/bella-nuxt/pages/acesso.vue")
  },
  {
    name: "limpar-cache",
    path: "/limpar-cache",
    meta: limpar_45cacheEO4RwB3_zUACu_pJQjtco_htqtnqAhjWmoeT68BY6EIMeta || {},
    component: () => import("/home/bella/vhosts/bella-nuxt/pages/limpar-cache.vue")
  },
  {
    name: "language-live",
    path: "/:language()/live",
    meta: {"middleware":["not-found-lang"]},
    component: () => import("/home/bella/vhosts/bella-nuxt/pages/[language]/live.vue")
  },
  {
    name: "language",
    path: "/:language()",
    meta: {"middleware":["not-found-lang"]},
    component: () => import("/home/bella/vhosts/bella-nuxt/pages/[language]/index.vue")
  },
  {
    name: "language-login",
    path: "/:language()/login",
    meta: {"middleware":["not-found-lang"]},
    component: () => import("/home/bella/vhosts/bella-nuxt/pages/[language]/login.vue")
  },
  {
    name: "language-sobre",
    path: "/:language()/sobre",
    meta: {"middleware":["not-found-lang"]},
    component: () => import("/home/bella/vhosts/bella-nuxt/pages/[language]/sobre.vue")
  },
  {
    name: "language-ecards",
    path: "/:language()/ecards",
    meta: {"middleware":["not-found-lang"]},
    component: () => import("/home/bella/vhosts/bella-nuxt/pages/[language]/ecards.vue")
  },
  {
    name: "language-contato",
    path: "/:language()/contato",
    meta: {"middleware":["not-found-lang"]},
    component: () => import("/home/bella/vhosts/bella-nuxt/pages/[language]/contato.vue")
  },
  {
    name: "language-renovar",
    path: "/:language()/renovar",
    meta: {"middleware":["not-found-lang"]},
    component: () => import("/home/bella/vhosts/bella-nuxt/pages/[language]/renovar.vue")
  },
  {
    name: "language-freetour",
    path: "/:language()/freetour",
    component: () => import("/home/bella/vhosts/bella-nuxt/pages/[language]/freetour.vue")
  },
  {
    name: "language-imprensa",
    path: "/:language()/imprensa",
    component: () => import("/home/bella/vhosts/bella-nuxt/pages/[language]/imprensa.vue")
  },
  {
    name: "language-blog",
    path: "/:language()/blog",
    meta: {"middleware":["not-found-lang"]},
    component: () => import("/home/bella/vhosts/bella-nuxt/pages/[language]/blog/index.vue")
  },
  {
    name: "language-cancelform",
    path: "/:language()/cancelform",
    meta: {"middleware":["not-found-lang","check-login"]},
    component: () => import("/home/bella/vhosts/bella-nuxt/pages/[language]/cancelform.vue")
  },
  {
    name: "language-minhaconta",
    path: "/:language()/minhaconta",
    meta: {"middleware":["not-found-lang","check-login"]},
    component: () => import("/home/bella/vhosts/bella-nuxt/pages/[language]/minhaconta.vue")
  },
  {
    name: "language-lives",
    path: "/:language()/lives",
    meta: {"middleware":["not-found-lang"]},
    component: () => import("/home/bella/vhosts/bella-nuxt/pages/[language]/lives/index.vue")
  },
  {
    name: "language-assine",
    path: "/:language()/assine",
    meta: {"middleware":["not-found-lang"]},
    component: () => import("/home/bella/vhosts/bella-nuxt/pages/[language]/assine/index.vue")
  },
  {
    name: "language-assine-turbo",
    path: "/:language()/assine/turbo",
    meta: {"middleware":["not-found-lang"]},
    component: () => import("/home/bella/vhosts/bella-nuxt/pages/[language]/assine/turbo.vue")
  },
  {
    name: "language-videos",
    path: "/:language()/videos",
    meta: {"middleware":["not-found-lang"]},
    component: () => import("/home/bella/vhosts/bella-nuxt/pages/[language]/videos/index.vue")
  },
  {
    name: "language-assine-period",
    path: "/:language()/assine/period",
    meta: periody88SPolOMiNs_45PjbSfqPayVSbTTyelmIgosUdRr7c_45YMeta || {},
    component: () => import("/home/bella/vhosts/bella-nuxt/pages/[language]/assine/period.vue")
  },
  {
    name: "language-colunas",
    path: "/:language()/colunas",
    meta: {"middleware":["not-found-lang"]},
    component: () => import("/home/bella/vhosts/bella-nuxt/pages/[language]/colunas/index.vue")
  },
  {
    name: "language-modelos",
    path: "/:language()/modelos",
    meta: {"middleware":["not-found-lang"]},
    component: () => import("/home/bella/vhosts/bella-nuxt/pages/[language]/modelos/index.vue")
  },
  {
    name: "language-afiliado",
    path: "/:language()/afiliado",
    meta: {"middleware":["not-found-lang","afiliado-convidado"]},
    component: () => import("/home/bella/vhosts/bella-nuxt/pages/[language]/afiliado/index.vue")
  },
  {
    name: "language-assine-account",
    path: "/:language()/assine/account",
    meta: {"middleware":["not-found-lang"]},
    component: () => import("/home/bella/vhosts/bella-nuxt/pages/[language]/assine/account.vue")
  },
  {
    name: "language-assine-credits",
    path: "/:language()/assine/credits",
    component: () => import("/home/bella/vhosts/bella-nuxt/pages/[language]/assine/credits.vue")
  },
  {
    name: "language-bellacloud-top",
    path: "/:language()/bellacloud/top",
    component: () => import("/home/bella/vhosts/bella-nuxt/pages/[language]/bellacloud/top.vue")
  },
  {
    name: "language-palpitao",
    path: "/:language()/palpitao",
    meta: {"middleware":["not-found-lang"]},
    component: () => import("/home/bella/vhosts/bella-nuxt/pages/[language]/palpitao/index.vue")
  },
  {
    name: "language-previas-gratis",
    path: "/:language()/previas-gratis",
    meta: { ...(previas_45gratisUu0GHc_451SKMRWYov_tWDHMi0qa9ivXF8X5MiT9SNXh4Meta || {}), ...{"middleware":["not-found-lang"]} },
    component: () => import("/home/bella/vhosts/bella-nuxt/pages/[language]/previas-gratis.vue")
  },
  {
    name: painels6xd1kFlDQDsodIv2XUn2HSv8mMI778SE4dxElCN54EMeta?.name,
    path: "/:language()/afiliado/painel",
    meta: {"middleware":["not-found-lang","afiliado-auth"]},
    component: () => import("/home/bella/vhosts/bella-nuxt/pages/[language]/afiliado/painel.vue"),
    children: [
  {
    name: "language-afiliado-painel",
    path: "",
    component: () => import("/home/bella/vhosts/bella-nuxt/pages/[language]/afiliado/painel/index.vue")
  },
  {
    name: "language-afiliado-painel-links",
    path: "links",
    component: () => import("/home/bella/vhosts/bella-nuxt/pages/[language]/afiliado/painel/links.vue")
  },
  {
    name: "language-afiliado-painel-material",
    path: "material",
    component: () => import("/home/bella/vhosts/bella-nuxt/pages/[language]/afiliado/painel/material.vue")
  }
]
  },
  {
    name: "language-area-gold",
    path: "/:language()/area-gold",
    meta: {"middleware":["not-found-lang"]},
    component: () => import("/home/bella/vhosts/bella-nuxt/pages/[language]/area-gold/index.vue")
  },
  {
    name: "language-assine-checkout",
    path: "/:language()/assine/checkout",
    meta: {"middleware":["not-found-lang"]},
    component: () => import("/home/bella/vhosts/bella-nuxt/pages/[language]/assine/checkout.vue")
  },
  {
    name: "language-making-of",
    path: "/:language()/making-of",
    meta: {"middleware":["not-found-lang"]},
    component: () => import("/home/bella/vhosts/bella-nuxt/pages/[language]/making-of/index.vue")
  },
  {
    name: "language-bellacloud",
    path: "/:language()/bellacloud",
    meta: {"middleware":["not-found-lang"]},
    component: () => import("/home/bella/vhosts/bella-nuxt/pages/[language]/bellacloud/index.vue")
  },
  {
    name: "language-blog-id-slug",
    path: "/:language()/blog/:id()/:slug()",
    meta: {"middleware":["not-found-lang"]},
    component: () => import("/home/bella/vhosts/bella-nuxt/pages/[language]/blog/[id]/[slug].vue")
  },
  {
    name: "language-homepage-preview",
    path: "/:language()/homepage-preview",
    component: () => import("/home/bella/vhosts/bella-nuxt/pages/[language]/homepage-preview.vue")
  },
  {
    name: "language-me-credits",
    path: "/:language()/me/credits",
    meta: {"middleware":["check-login","not-found-lang"]},
    component: () => import("/home/bella/vhosts/bella-nuxt/pages/[language]/me/credits/index.vue")
  },
  {
    name: "language-publicidade",
    path: "/:language()/publicidade",
    meta: {"middleware":["not-found-lang"]},
    component: () => import("/home/bella/vhosts/bella-nuxt/pages/[language]/publicidade/index.vue")
  },
  {
    name: "language-modelos-name-live",
    path: "/:language()/modelos/:name()/live",
    meta: {"middleware":["not-found-lang"]},
    component: () => import("/home/bella/vhosts/bella-nuxt/pages/[language]/modelos/[name]/live.vue")
  },
  {
    name: "language-modelos-name",
    path: "/:language()/modelos/:name()",
    meta: {"middleware":["not-found-lang"]},
    component: () => import("/home/bella/vhosts/bella-nuxt/pages/[language]/modelos/[name]/index.vue")
  },
  {
    name: "language-modelos-name-photo",
    path: "/:language()/modelos/:name()/photo",
    meta: {"middleware":["not-found-lang"]},
    component: () => import("/home/bella/vhosts/bella-nuxt/pages/[language]/modelos/[name]/photo.vue")
  },
  {
    name: "language-modelos-name-video",
    path: "/:language()/modelos/:name()/video",
    meta: {"middleware":["not-found-lang"]},
    component: () => import("/home/bella/vhosts/bella-nuxt/pages/[language]/modelos/[name]/video.vue")
  },
  {
    name: "language-modelos-name-perfil",
    path: "/:language()/modelos/:name()/perfil",
    meta: {"middleware":["not-found-lang"]},
    component: () => import("/home/bella/vhosts/bella-nuxt/pages/[language]/modelos/[name]/perfil.vue")
  },
  {
    name: "language-publicidade-dna-bella",
    path: "/:language()/publicidade/dna-bella",
    meta: {"middleware":["not-found-lang"]},
    component: () => import("/home/bella/vhosts/bella-nuxt/pages/[language]/publicidade/dna-bella.vue")
  },
  {
    name: "language-lives-categoria-slug",
    path: "/:language()/lives/categoria/:slug()",
    meta: {"middleware":["not-found-lang"]},
    component: () => import("/home/bella/vhosts/bella-nuxt/pages/[language]/lives/categoria/[slug].vue")
  },
  {
    name: "language-modelos-name-credits",
    path: "/:language()/modelos/:name()/credits",
    meta: {"middleware":["not-found-lang"]},
    component: () => import("/home/bella/vhosts/bella-nuxt/pages/[language]/modelos/[name]/credits.vue")
  },
  {
    name: "language-assine-checkout-success",
    path: "/:language()/assine/checkout-success",
    component: () => import("/home/bella/vhosts/bella-nuxt/pages/[language]/assine/checkout-success.vue")
  },
  {
    name: "language-politica-de-privacidade",
    path: "/:language()/politica-de-privacidade",
    meta: {"middleware":["not-found-lang"]},
    component: () => import("/home/bella/vhosts/bella-nuxt/pages/[language]/politica-de-privacidade.vue")
  },
  {
    name: "language-videos-categoria-slug",
    path: "/:language()/videos/categoria/:slug()",
    meta: {"middleware":["not-found-lang"]},
    component: () => import("/home/bella/vhosts/bella-nuxt/pages/[language]/videos/categoria/[slug].vue")
  },
  {
    name: "language-cancel-subscribe-token",
    path: "/:language()/cancel-subscribe/:token()",
    component: () => import("/home/bella/vhosts/bella-nuxt/pages/[language]/cancel-subscribe/[token].vue")
  },
  {
    name: "language-modelos-name-making-of",
    path: "/:language()/modelos/:name()/making-of",
    meta: {"middleware":["not-found-lang"]},
    component: () => import("/home/bella/vhosts/bella-nuxt/pages/[language]/modelos/[name]/making-of.vue")
  },
  {
    name: "language-modelos-name-wallpaper",
    path: "/:language()/modelos/:name()/wallpaper",
    meta: {"middleware":["not-found-lang"]},
    component: () => import("/home/bella/vhosts/bella-nuxt/pages/[language]/modelos/[name]/wallpaper.vue")
  },
  {
    name: "language-modelos-categoria-slug",
    path: "/:language()/modelos/categoria/:slug()",
    meta: {"middleware":["not-found-lang"]},
    component: () => import("/home/bella/vhosts/bella-nuxt/pages/[language]/modelos/categoria/[slug].vue")
  },
  {
    name: "language-politica-de-cancelamento",
    path: "/:language()/politica-de-cancelamento",
    meta: {"middleware":["not-found-lang"]},
    component: () => import("/home/bella/vhosts/bella-nuxt/pages/[language]/politica-de-cancelamento.vue")
  },
  {
    name: "language-programa-afiliados",
    path: "/:language()/programa-afiliados",
    meta: {"middleware":["not-found-lang"]},
    component: () => import("/home/bella/vhosts/bella-nuxt/pages/[language]/programa-afiliados/index.vue")
  },
  {
    name: "language-making-of-categoria-slug",
    path: "/:language()/making-of/categoria/:slug()",
    meta: {"middleware":["not-found-lang"]},
    component: () => import("/home/bella/vhosts/bella-nuxt/pages/[language]/making-of/categoria/[slug].vue")
  },
  {
    name: "language-me-credits-videos-downloads",
    path: "/:language()/me/credits/videos-downloads",
    meta: {"middleware":["not-found-lang","check-login"]},
    component: () => import("/home/bella/vhosts/bella-nuxt/pages/[language]/me/credits/videos-downloads.vue")
  },
  {
    name: "language-password-reset-email-token",
    path: "/:language()/password-reset/:email()/:token()",
    component: () => import("/home/bella/vhosts/bella-nuxt/pages/[language]/password-reset/[email]/[token].vue")
  },
  {
    name: "language-assine-checkout-credits-success",
    path: "/:language()/assine/checkout-credits-success",
    component: () => import("/home/bella/vhosts/bella-nuxt/pages/[language]/assine/checkout-credits-success.vue")
  },
  {
    name: "language-programa-afiliados-complement",
    path: "/:language()/programa-afiliados/:complement()",
    meta: {"middleware":["not-found-lang"]},
    component: () => import("/home/bella/vhosts/bella-nuxt/pages/[language]/programa-afiliados/[complement].vue")
  },
  {
    name: "language-bellacloud-album-view-albumId-nameAlbum",
    path: "/:language()/bellacloud/album/view/:albumId()/:nameAlbum()",
    component: () => import("/home/bella/vhosts/bella-nuxt/pages/[language]/bellacloud/album/view/[albumId]/[nameAlbum].vue")
  },
  {
    name: "language-colunas-catergoriaId-categoriaName",
    path: "/:language()/colunas/:catergoriaId()/:categoriaName()",
    meta: indexWcfihC1eoFvXOl_vo3_459uhj_45Z6y9FBb7fKH7TbagXsEMeta || {},
    component: () => import("/home/bella/vhosts/bella-nuxt/pages/[language]/colunas/[catergoriaId]/[categoriaName]/index.vue")
  },
  {
    name: "language-colunas-catergoriaId-categoriaName-colunaId-colunaName",
    path: "/:language()/colunas/:catergoriaId()/:categoriaName()/:colunaId()/:colunaName()",
    meta: {"middleware":["not-found-lang"]},
    component: () => import("/home/bella/vhosts/bella-nuxt/pages/[language]/colunas/[catergoriaId]/[categoriaName]/[colunaId]/[colunaName].vue")
  }
]